import './products.scss';
import * as React from 'react';
import useProducts from '../../hooks/staticQueries/aboutUs/useProducts';
import { ColourUtils } from '../../utils/colours';
import { Card } from '../layout/card';
import { RMButton } from '../layout/rmButton';
import { LazyCosmosImage } from '../media/cosmosImage';
export const ProductsWrapper = () => {
    const { products } = useProducts();
    return (<div className="products-wrapper">
      {products.map((product) => (<Product product={product} key={product.product_name}/>))}
    </div>);
};
export const Product = ({ product }) => (<Card className="product" to={product.product_link}>
    <div className="product-logo">
      <LazyCosmosImage ticket={product.product_logo[0].ticket} alt={`${product.product_name} logo`} aria-hidden="true"/>
    </div>

    <p className="product-description">{product.product_description}</p>

    {product.product_link && (<RMButton variant="brand" style={ColourUtils.backgroundColourWithColouredShadow(product.brand_colour)} name={`more about ${product.product_name}`}>
        {`More about ${product.product_name}`}
      </RMButton>)}
  </Card>);
